import { render, staticRenderFns } from "./_inbox.vue?vue&type=template&id=51712e02&scoped=true&lang=pug&"
import script from "./_inbox.vue?vue&type=script&lang=js&"
export * from "./_inbox.vue?vue&type=script&lang=js&"
import style0 from "./_inbox.vue?vue&type=style&index=0&id=51712e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51712e02",
  null
  
)

export default component.exports